import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';
import DescriptionIcon from '@mui/icons-material/Description';

const CommuniqueGSSPage = () => {
  const imageOuverture = '/assets/gss/GSS_2_VS.jpeg';   
  const imageParticipants = '/assets/gss/GSS_2_P.jpeg';

  return (
    <div style={styles.container}>
      <NavigationBar />

      <main style={styles.main}>
        <header style={styles.header}>
          <div style={styles.badges}>
            <span style={styles.badgeRed}>INSBU</span>
            <span style={styles.badgeGreen}>GSS</span>
            <span style={styles.badgeGray}>Communiqué officiel</span>
          </div>

          <h1 style={styles.title}>
            Réunion du Groupe Sectoriel Statistique (GSS) du 2<sup>ème</sup> trimestre 2026
          </h1>

          <div style={styles.meta}>
            <span style={styles.metaItem}>
              <CalendarTodayIcon style={styles.metaIcon} /> Publié le 28 juillet 2026
            </span>
            <span style={styles.metaItem}>
              <LocationOnIcon style={styles.metaIcon} /> Bujumbura, Burundi
            </span>
            <span style={styles.metaItem}>
              <AccessTimeIcon style={styles.metaIcon} /> Lecture 5 min
            </span>
          </div>

          {/* PHOTO DE COUVERTURE : ouverture de la réunion */}
          <div style={styles.imageWrapper}>
            <img
              src={imageOuverture}
              alt="Ouverture de la réunion du GSS – Ministère des Finances, Bujumbura"
              style={styles.heroImage}
              onError={(e) => { e.target.src = 'https://placehold.co/820x420/008D36/FFFFFF?text=INSBU+GSS+Ouverture'; }}
            />
            <p style={styles.imageCaption}>
              La salle des réunions du Ministère des Finances, du Budget et de l'Économie Numérique – ouverture de la session du GSS du 2<sup>ème</sup> trimestre 2026.
            </p>
          </div>

          <p style={styles.chapeau}>
            L'<strong>INSBU</strong> a organisé, ce <strong>mardi 28 juillet 2026</strong> dans la grande salle des réunions du Ministère des Finances, du Budget et de l’Économie Numérique, la réunion statutaire du <strong>Groupe Sectoriel Statistique (GSS)</strong>.
            Les échanges ont porté sur cinq points majeurs : les résultats de l’enquête nationale agricole, l’état d’avancement du RGPHAE, les méthodologies de collecte des données administratives et de l’emploi informel, ainsi que les recommandations de l’évaluation à mi‑parcours de la SNDS‑III.
          </p>
        </header>

        <article style={styles.article}>

          {/* SECTION 1 : ENAB */}
          <h2 style={styles.h2}>
            <SchoolIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            1. Résultats de l’Enquête Nationale Agricole du Burundi (ENAB), campagne 2024-2025
          </h2>
          <p style={styles.p}>
            Les résultats présentés sont issus du rapport de campagne. Les données révèlent que le nombre total de ménages agricoles s’élève à <strong>2.071.157</strong>, pour une population agricole totale de <strong>10.175.239</strong> personnes (dont 47,2 % d’hommes et 52,8 % de femmes). La production totale des cultures vivrières, exprimée en tonnes équivalent céréale (TEC), s’établit à <strong>265.104.543 TEC</strong>. Cette production se répartit comme suit : céréales (37,5 %), légumineuses (33,5 %), banane (19,1 %), oléagineux (9,6 %) et tubercules et racines (0,2 %).
          </p>

          {/* SECTION 2 : RGPHAE */}
          <h2 style={styles.h2}>
            <GroupsIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            2. État d'avancement des activités du RGPHAE
          </h2>
          <p style={styles.p}>
            Le Bureau Central du Recensement (BCR) a fait le point sur le quatrième Recensement Général de la Population et de l’Habitat et le premier Recensement Général de l’Agriculture et de l’Élevage (RGPHAE). Conformément au décret n°100/109 du 30 novembre 2020, le BCR assure la coordination technique nationale et la conduite des opérations sur l’ensemble du territoire. Les innovations majeures de cette opération sont : l’utilisation de la nouvelle technologie pour la collecte des données dans toutes les phases, l’intégration du module de base du Recensement Général de l’Agriculture et de l’Élevage (RGEA) au RGPH, le développement de bases de données géo‑référencées et l’analyse des données communautaires.
          </p>

          {/* Photo des participants */}
          <div style={styles.participantsWrapper}>
            <img
              src={imageParticipants}
              alt="Participants à la réunion du GSS"
              style={styles.participantsImg}
              onError={(e) => { e.target.src = 'https://placehold.co/820x350/008D36/FFFFFF?text=Participants+au+GSS'; }}
            />
            <p style={styles.participantsCaption}>
              Vue d’ensemble des participants à la réunion du GSS – 28 juillet 2026.
            </p>
          </div>

          {/* SECTION 3 : DHIS2 */}
          <h2 style={styles.h2}>
            <DescriptionIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            3. Méthodologie de collecte des données de source administrative (DHIS2)
          </h2>
          <p style={styles.p}>
            Le Ministère de l’Intérieur, du Développement Communautaire et de la Sécurité Publique (MIDCSP) a présenté la production des statistiques sectorielles à l’aide de l’outil DHIS2. Cet outil concerne les secteurs de l’administration du territoire, du développement communautaire et de la sécurité publique. La collecte porte sur des indicateurs variés : état civil, travaux communautaires, microfinances sous tutelle, finances communales, criminalité, migrations, réduction des risques et gestion des catastrophes, monitoring de la violence armée, et indicateurs sanitaires. Les données seront renseignées journalièrement, mensuellement ou annuellement. L’opération dispose de <strong>648 tablettes</strong> mises à disposition par l’INSBU, avec des besoins complémentaires de 15 ordinateurs, 2 serveurs pour back up et deux véhicules de terrain pour le suivi.
          </p>

          {/* SECTION 4 : EESIBU */}
          <h2 style={styles.h2}>
            <GroupsIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            4. Méthodologie de collecte sur l’emploi du secteur informel (EESIBU 2026)
          </h2>
          <p style={styles.p}>
            L’INSBU a présenté l’Enquête Nationale sur l’Emploi et le Secteur Informel au Burundi (EESIBU). Cette enquête est un outil de suivi de la Vision Burundi 2040-2060, du Plan National de Développement (PND) révisé 2018-2027, des Objectifs de Développement Durable (ODD 8) et du Système de Comptabilité Nationale (SCN 2008). Elle repose sur une approche « 1‑2 » intégrée : un volet ménages et un volet entreprises. L’échantillonnage est stratifié à deux degrés, basé sur le 4<sup>e</sup> RGPHAE (2.766.460 ménages répartis dans 14.110 zones de dénombrement), avec un tirage de 879 grappes et un échantillon total de 12.682 ménages, assurant une représentativité provinciale. La collecte utilise la méthode CAPI sur tablettes/smartphones avec les logiciels Survey Solutions ou CSPro.
          </p>

          {/* SECTION 5 : SNDS-III */}
          <h2 style={styles.h2}>
            <WarningIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#E30613' }} />
            5. Recommandations de l'évaluation à mi‑parcours de la SNDS‑III
          </h2>
          <p style={styles.p}>
            L’évaluation à mi‑parcours de la troisième Stratégie Nationale de Développement de la Statistique (SNDS III, 2022-2026) a été présentée. Le taux de mise en œuvre global est de <strong>65 %</strong>. Les résultats par axe stratégique sont les suivants :
          </p>
          <ul style={styles.ul}>
            <li style={styles.li}><strong>Axe 1</strong> (Rénovation du cadre réglementaire &amp; renforcement de la gouvernance) : <strong>81,5 %</strong></li>
            <li style={styles.li}><strong>Axe 2</strong> (Amélioration de la couverture &amp; qualité de la production statistique) : <strong>66,6 %</strong></li>
            <li style={styles.li}><strong>Axe 3</strong> (Amélioration des ressources humaines, matérielles et financières) : <strong>35,5 %</strong></li>
          </ul>
          <p style={styles.p}>
            Les recommandations formulées à l’endroit du Gouvernement incluent notamment :
          </p>
          <ul style={styles.ul}>
            <li style={styles.li}>la publication et la diffusion du rapport d’évaluation ;</li>
            <li style={styles.li}>l’élaboration d’une stratégie de mobilisation des ressources financières ;</li>
            <li style={styles.li}>l’organisation d’une table ronde sur le financement du système statistique national en prélude à la SNDS IV ;</li>
            <li style={styles.li}>le lancement du processus d’élaboration de la SNDS IV au cours du 3<sup>ème</sup> trimestre 2026 ;</li>
            <li style={styles.li}>la dotation du système statistique burundais d’un Fonds national de développement de la statistique, conformément aux recommandations de la Charte africaine de la Statistique et de la SHaSA 2.</li>
          </ul>

          {/* CONCLUSION */}
          <div style={styles.conclusion}>
            <p style={styles.p}>
              La réunion du GSS du 2<sup>ème</sup> trimestre 2026 a permis de faire le point sur des avancées majeures du système statistique national, tout en identifiant les défis à relever pour les années à venir. L’INSBU et ses partenaires restent mobilisés pour renforcer la production et la diffusion des données statistiques au Burundi.
            </p>
            <p style={styles.vive}>
              <strong>Vive le système statistique national, vive le Burundi !</strong>
            </p>
          </div>

        </article>
      </main>

      <Footer />
    </div>
  );
};

// ================= STYLES (repris de TrainingLaunchPageB) =================
const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '820px',
    margin: '0 auto',
    padding: '40px 20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '30px',
    borderBottom: '2px solid #e0e0e0',
  },
  badges: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  badgeRed: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGreen: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGray: {
    backgroundColor: '#6c757d',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    color: '#1a1a1a',
    fontSize: '2.4rem',
    fontWeight: '700',
    lineHeight: 1.2,
    marginBottom: '12px',
    letterSpacing: '-0.3px',
  },
  meta: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '20px',
    fontSize: '0.9rem',
    color: '#6c757d',
  },
  metaItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  metaIcon: {
    fontSize: '1rem',
    color: '#008D36',
  },
  imageWrapper: {
    marginBottom: '24px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '420px',
    objectFit: 'cover',
    display: 'block',
    borderRadius: '8px 8px 0 0',
  },
  imageCaption: {
    fontSize: '0.85rem',
    color: '#6c757d',
    textAlign: 'center',
    padding: '8px 0 4px 0',
    fontStyle: 'italic',
    backgroundColor: '#fafafa',
    margin: 0,
    borderBottom: '1px solid #eaeaea',
    borderRadius: '0 0 8px 8px',
  },
  chapeau: {
    fontSize: '1.2rem',
    lineHeight: 1.7,
    color: '#2c3e50',
    maxWidth: '700px',
    margin: '0 auto',
    fontWeight: '400',
    borderLeft: '4px solid #008D36',
    paddingLeft: '20px',
    textAlign: 'left',
  },
  article: {
    backgroundColor: 'white',
    padding: '40px 45px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    marginBottom: '40px',
  },
  h2: {
    color: '#008D36',
    fontSize: '1.5rem',
    fontWeight: '600',
    marginTop: '40px',
    marginBottom: '16px',
    paddingBottom: '6px',
    borderBottom: '2px solid #eaeaea',
    display: 'flex',
    alignItems: 'center',
  },
  p: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '20px',
    textAlign: 'justify',
  },
  ul: {
    paddingLeft: '20px',
    marginBottom: '20px',
  },
  li: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '8px',
  },
  participantsWrapper: {
    margin: '30px 0',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  participantsImg: {
    width: '100%',
    height: 'auto',
    maxHeight: '350px',
    objectFit: 'cover',
    display: 'block',
    borderRadius: '8px 8px 0 0',
  },
  participantsCaption: {
    fontSize: '0.85rem',
    color: '#6c757d',
    textAlign: 'center',
    padding: '8px 0',
    fontStyle: 'italic',
    backgroundColor: '#fafafa',
    margin: 0,
    borderBottom: '1px solid #eaeaea',
    borderRadius: '0 0 8px 8px',
  },
  conclusion: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #eaeaea',
  },
  vive: {
    fontSize: '1.3rem',
    fontWeight: '700',
    color: '#008D36',
    textAlign: 'center',
    marginTop: '20px',
    letterSpacing: '0.5px',
  },
};

export default CommuniqueGSSPage;